import React from 'react';
import { UseFormReturn } from 'react-hook-form';
import {
    EntityPanelFormGroup,
    EntityPanelGroupHeader,
} from '../../panels/entity-panels/entity-panel-components';
import { EventPanelFormType, EventPanelOptions } from '@mark43/cad-api';
import { FormSelect } from '../../forms/integrated-form-controls/form-select';
import { FormTextarea } from '../../forms/integrated-form-controls/form-text-area';

export function EventPanelFormClearEventFields(props: {
    form: UseFormReturn<EventPanelFormType>;
    eventPanelOptions: EventPanelOptions;
}): React.ReactElement {
    const eventForm = props.form;
    return (
        <EntityPanelFormGroup>
            <EntityPanelGroupHeader title="Clear Event" />
            <FormSelect
                control={eventForm.control}
                label="Primary Disposition"
                name="clearEventPrimaryDisposition"
                options={props.eventPanelOptions.dispositionOptions}
                asEditable={false}
            />
            <FormSelect
                control={eventForm.control}
                label="Additional Disposition"
                name="clearEventAdditionalDispositions"
                options={props.eventPanelOptions.dispositionOptions}
                isMultiple={true}
                asEditable
            />
            <FormTextarea
                control={eventForm.control}
                label="Comments"
                name="clearEventComments"
                asEditable
            />
        </EntityPanelFormGroup>
    );
}
